<template>
  <a-modal :title="ModalTitle" v-model="visible" :confirmLoading="confirmLoading"
    cancelText="取消" okText="保存" width="500px"
    @ok="handleOk" @cancel="handleCancel">
    <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
    <a-form :form="form" layout="vertical">
      <a-form-item v-for="(item, index) of formData" :key="index" :label="item.label">
        <a-input v-if="item.type === 'input'" v-decorator="[item.name, { rules: item.rules }]"/>
        <a-date-picker v-if="item.type === 'date'" style="width: 100%"  v-decorator="[item.name, { rules: item.rules }]" format="YYYY-MM-DD"/>
        <a-select :disabled="isEdit?true:false" v-else-if="item.type === 'select'" placeholder="请选择"
           v-decorator="[item.name, { rules: item.rules }]">
          <a-select-option v-for="(d, index) of seleteItems[item.items.data]" :key="index" :value="d[item.items.value]">{{ d[item.items.label] }}</a-select-option>
        </a-select>
        <a-textarea v-else-if="item.type === 'textarea'" :rows="4"
           v-decorator="[item.name, { rules: item.rules }]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
const formData = [
  {
    name: 'meeting_id',
    label: '所属活动',
    type: 'select',
    rules: [{ required: true, message: '请输入所属活动!' }],
    items: {
      data: 'classCategorys',
      label: 'meeting_name',
      value: 'meeting_id'
    }
  },
  {
    name: 'name',
    label: '票名称',
    type: 'input',
    rules: [{ required: true, message: '请输入票名称!' }]
  },
  {
    name: 'price',
    label: '价格',
    type: 'input',
    rules: [{ required: true, message: '请输入价格!' }]
  },
  {
    name: 'max_count',
    label: '票总数',
    type: 'input',
    rules: [{ required: true, message: '请输入票总数!' }]
  },
]
export default {
  name: 'EditModal',
  inject: ['parent'],
  props: {
    item: Object,
    isEdit:Number
  },

  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      ModalTitle: '新增',
      visible: false,
      loading: false,
      confirmLoading: false,
      formData,
      form: this.$form.createForm(this),
      seleteItems: {
        classCategorys: []
      }
    }
  },

  async created() {
    this.visible = true
    if (this.item) {
      this.loading = true
    }
    await this.getClassCategory()
    await this.$nextTick()
    if (this.item) {
      this.ModalTitle = '编辑'
      // let item = await this.getDetail(this.item.type_id)
      let formFields = {}
      for (let d of formData) {
        formFields[d.name] = this.item[d.name]
      }
      this.form.setFieldsValue(formFields)
      this.loading = false
    }
  },

  beforeDestroy() {
    this.visible = false
  },

  methods: {
    async getClassCategory() {
      let res = await this.$store.dispatch('meetingCampaignAction', {})
      this.seleteItems.classCategorys = res.items
    },
    async getDetail(type_id) {
      let res = await this.$store.dispatch('meetingTicketsDetailAction', {data: {type_id}})
      return res.data
    },
    async handleOk() {
      this.confirmLoading=true;
      try {
        const { item, form } = this
        let params = await form.validateFields()
        if (params) {
          if (item) {
            params.type_id = item.type_id
          }
          let res = await this.$store.dispatch(item ? 'meetingTicketsUpdateTypeAction' : 'meetingTicketsAddDiscountTypeAction', { data: params })
          if(res) {
            form.resetFields()
            this.parent.hideEditModal(1)
          }
        }
      } catch {
      }
			this.confirmLoading=false;
    },
    handleCancel() {
      this.parent.hideEditModal(0)
    }
  }
}
</script>
